import $ from 'cash-dom'
import Transitioner from '../utils/transitioner'

export default class AccordionList {
  constructor({ $container } = {}) {
    this.$container = $container
    this.active = null

    this.constructElements()

    this.constructEvents()

    this.constructTransitioner()
  }

  static init() {
    const $containers = $(AccordionList.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new AccordionList({ $container: $(elem) })
      })
    }
  }

  constructElements() {
    this.$items = this.$container.find(AccordionList.selectors.item)
  }

  constructEvents() {
    this.$container
      .on('click', AccordionList.selectors.itemHeader, (e) => this.handleClickHeader({ e }))
  }

  constructTransitioner() {
    this.itemContentTransitioner = {}

    this.$items.each((i, elem) => {
      const $item = $(elem)
      const $content = $item.find(AccordionList.selectors.itemContent)
      const itemIndex = $item.data('index')

      this.itemContentTransitioner[itemIndex] = new Transitioner({
        $container: $content,
      })
    })
  }

  doCloseItemActive() {
    const $item = this.$items.filter(`[data-index="${this.active}"]`)

    this.doCloseItem({ $item, itemIndex: this.active })
  }

  doCloseItem({ $item, itemIndex }) {
    this.active = null

    this.itemContentTransitioner[itemIndex].doSlideUp()

    $item
      .removeClass(AccordionList.classes.active)
      .attr('aria-hidden', true)
  }

  doOpenItem({ $item, itemIndex }) {
    if (this.active !== null) {
      this.doCloseItemActive()
    }

    this.active = itemIndex

    this.itemContentTransitioner[itemIndex].doSlideDown()

    $item
      .addClass(AccordionList.classes.active)
      .attr('aria-hidden', false)
  }

  handleClickHeader({ e }) {
    e.preventDefault()

    const $item = $(e.currentTarget).closest(AccordionList.selectors.item)
    const itemIndex = $item.data('index')

    if (itemIndex !== this.active) {
      this.doOpenItem({ $item, itemIndex })
    } else {
      this.doCloseItem({ $item, itemIndex })
    }
  }
}

AccordionList.selectors = {
  container: '.js-accordion-list',
  item: '.js-accordion-list-item',
  itemContent: '.js-accordion-list-item-content',
  itemHeader: '.js-accordion-list-item-header',
}

AccordionList.classes = {
  active: 'o-list-item--active',
}
